module.exports = __webpack_public_path__ + "static/5-b27b9ed77cef0ddf06c4724ccf104b67.jpg";